import styled from 'styled-components';

export const TopBarContainer = styled.nav<{ theme: any }>(({ theme }) => ({
  backgroundColor: theme.topBarSectionBackgroundColor,
  width: '100%'
}));

export const ClickUIWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    background: theme.styleguideColors.backgroundTertiary,
    width: '100%',
    maxWidth: ['540px', '720px', '1200px'],
    margin: '0 auto',
    padding: '0 12px'
  })
);